export function resolveDisplayedFindingTitle(item = {}) {
    const findingTitle = `${item.findingTitle || ""}`.trim()
    const findingText = `${item.findingText || ""}`.trim()

    if (!findingTitle) return ""
    if (findingTitle.length === 1 && findingText) return ""
    if (findingText && normalizeInlineWhitespace(findingTitle) === normalizeInlineWhitespace(findingText)) return ""

    return findingTitle
}

function normalizeInlineWhitespace(value) {
    return `${value || ""}`.replace(/\s+/g, " ").trim().toLowerCase()
}
